"use client";

import {
    ShareAltOutlined,
    LikeOutlined,
    DislikeOutlined,
    ClockCircleOutlined,
} from "@ant-design/icons";
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
} from "react-share";
import { formatDateString } from "@/lib/utils";
import { useEffect, useState } from "react";


export default function BlogMeta({ createdAt }: { createdAt: string }) {
    const [shareUrl, setShareUrl] = useState('');

    const title = "Check out this insightful post by GingerEdu!";
    const iconStyle = "rounded-full text-xs";
    const formattedDate = formatDateString(createdAt);

    useEffect(() => {
        setShareUrl(window.location.href);
    }, []);

    return (
        <div
            className="flex flex-col md:flex-row justify-between md:items-center w-full p-2 border-b-2 border-t-2 border-gray-300 gap-4"
        >
            <div className="flex items-center gap-2">
                <p className="flex text-sm gap-2 font-bold"> <ClockCircleOutlined /> {formattedDate} </p>
                {/* TODO ADD LIKE AND DISLIKE FUNCTIONALITY */}
                {/* <LikeOutlined className="text-lg"/>
                <DislikeOutlined className="text-lg"/> */}
            </div>
            <div className="flex items-center md:justify-center gap-2">
                <p className="text-center justify-center">
                    <ShareAltOutlined /> Share
                </p>
                <WhatsappShareButton url={shareUrl} title={title}>
                    <WhatsappIcon className={iconStyle} size={30} />
                </WhatsappShareButton>
                <FacebookShareButton
                    url={shareUrl}
                    title={title}
                    hashtag={"#gingeredu"}
                >
                    <FacebookIcon className={iconStyle} size={30} />
                </FacebookShareButton>
                <TwitterShareButton url={shareUrl} title={title}>
                    <TwitterIcon className={iconStyle} size={30} />
                </TwitterShareButton>
                <EmailShareButton
                    url={shareUrl}
                    subject={title}
                    body="This is a must-read from GingerEdu"
                >
                    <EmailIcon className={iconStyle} size={30} />
                </EmailShareButton>
            </div>
        </div>
    );
}
